// extracted by mini-css-extract-plugin
export var columnName = "comparisonchart-module--columnName--885d1";
export var customIcon = "comparisonchart-module--customIcon--8cc91";
export var headline = "comparisonchart-module--headline--08f8d";
export var mobileColumn = "comparisonchart-module--mobileColumn--64f27";
export var table = "comparisonchart-module--table--effb9";
export var tableContainer = "comparisonchart-module--tableContainer--b9220";
export var wrapper = "comparisonchart-module--wrapper--edeb2";